import { type ApiError } from 'src/lib/error';

import ApiActions from '../constants/ApiActions';
import RegisterActions from '../constants/RegisterActions';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

/* key names in use */
export const IS_REGISTERING_KEY = 'isRegistering';
export const REGISTRATION_ERROR_KEY = 'registrationError';
export const IS_BLOCKED_FROM_REGISTRATION = 'isBlockedFromRegistration';
export const REGISTRATION_ERROR_CODE_KEY = 'registrationErrorCode';

const INITIAL_STATE = Map({
  [IS_REGISTERING_KEY]: false,
  [REGISTRATION_ERROR_KEY]: '',
  [REGISTRATION_ERROR_CODE_KEY]: null as string | null,
  [IS_BLOCKED_FROM_REGISTRATION]: false,
});
export type RegisterState = typeof INITIAL_STATE;

// REGISTER REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.REGISTER_ATTEMPT]: registerAttempt,
  [ApiActions.REGISTER_SUCCESS]: registerSuccess,
  [ApiActions.REGISTER_FAIL]: registerFail,
  [RegisterActions.REGISTER_RESET]: registerReset,
  [RegisterActions.REGISTER_CLEAR_ERROR]: registerClearError,
  [RegisterActions.REGISTER_BLOCKED]: registerBlocked,
});

// CASE FUNCTIONS

function registerAttempt(state: RegisterState): RegisterState {
  return state.merge({
    [IS_REGISTERING_KEY]: true,
    [REGISTRATION_ERROR_CODE_KEY]: null,
    [REGISTRATION_ERROR_KEY]: '',
  });
}

function registerSuccess(state: RegisterState): RegisterState {
  return state.merge({
    [IS_REGISTERING_KEY]: false,
    [REGISTRATION_ERROR_KEY]: '',
  });
}

function registerFail(state: RegisterState, action: $TSFixMe): RegisterState {
  return state.merge({
    [IS_REGISTERING_KEY]: false,
    [REGISTRATION_ERROR_CODE_KEY]: (action.error as ApiError).errorType || null,
    [REGISTRATION_ERROR_KEY]: (action.error as ApiError).errorMessage,
  });
}

function registerReset(state: RegisterState): RegisterState {
  return state.merge({
    [IS_REGISTERING_KEY]: false,
    [REGISTRATION_ERROR_KEY]: '',
    [REGISTRATION_ERROR_CODE_KEY]: null,
    [IS_BLOCKED_FROM_REGISTRATION]: false,
  });
}

function registerClearError(state: RegisterState): RegisterState {
  return state.set(REGISTRATION_ERROR_CODE_KEY, null);
}

function registerBlocked(state: RegisterState): RegisterState {
  return state.set(IS_BLOCKED_FROM_REGISTRATION, true);
}
